var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParcel = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.5 6h.5V3H3v3zM20 21H4V7h16zM2 2.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H21v14.5a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5V7h-.5a.5.5 0 0 1-.5-.5zM7.5 11h9a.5.5 0 1 0 0-1h-9a.5.5 0 0 0 0 1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgParcel);
export default ForwardRef;